import '../../styles/globals.css'
function Header() {
    return (
        <header className="header">
        <div className="container">
            <div className="header-content">
                <div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
                    <a href="#">
                    <svg width="150" height="60" viewBox="0 0 180 90" xmlns="http://www.w3.org/2000/svg">
                        <style>
                            
                        </style>
                        <path d="M30,50 Q50,30 70,50 Q90,70 110,50 Q130,30 150,50 Q170,70 190,50" 
                                stroke="#0066cc" strokeWidth="2" fill="none"/>
                        <path d="M30,50 Q50,70 70,50 Q90,30 110,50 Q130,70 150,50 Q170,30 190,50" 
                                stroke="#00aa55" strokeWidth="2" fill="none"/>
                        <rect x="85" y="35" width="10" height="30" fill="#0066cc"/>
                        <rect x="70" y="45" width="40" height="10" fill="#00aa55"/>
                        <text x="30" y="90" className="dna-text">DNA</text>
                        <text x="80" y="90" className="saude-text">Saúde</text>
                    </svg>
                    </a>
                    <span style={{color: 'var(--primary)', fontSize: '18px', fontWeight: 'bold'}}>Corretora de Planos de Saúde</span>
                </div>
                <a href="#form" className="btn">Solicitar Cotação</a>
            </div>
        </div>
    </header>
    );
}
  
export default Header;